var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBookkeeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.774,
    height: 20,
    viewBox: "0 0 15.774 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M5.3,22.378h9.877a2.977,2.977,0,0,0,2.209-.749,3.045,3.045,0,0,0,.74-2.227V10.977a6.816,6.816,0,0,0-.069-1.057,2.359,2.359,0,0,0-.267-.786,3.664,3.664,0,0,0-.588-.751L12.211,3.311a2.894,2.894,0,0,0-1.1-.751,4.343,4.343,0,0,0-1.371-.183H5.3a2.969,2.969,0,0,0-2.2.753,3.05,3.05,0,0,0-.744,2.232V19.4A3.034,3.034,0,0,0,3.1,21.629,2.979,2.979,0,0,0,5.3,22.378Zm.111-1.666a1.385,1.385,0,0,1-1.038-.357,1.417,1.417,0,0,1-.347-1.028V5.438a1.409,1.409,0,0,1,.351-1.024,1.391,1.391,0,0,1,1.043-.362H9.459V9.277a1.906,1.906,0,0,0,.465,1.4,1.893,1.893,0,0,0,1.394.465h5.144v8.182a1.245,1.245,0,0,1-1.4,1.385ZM11.5,9.633a.459.459,0,0,1-.534-.534V4.319L16.2,9.633Z",
    transform: "translate(-2.354 -2.378)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBookkeeping);
export default __webpack_public_path__ + "static/media/Nav-Bookkeeping.97a2589537671f8f9d930104b02a9c83.svg";
export { ForwardRef as ReactComponent };